export default {
    'LZDS': {
        dop_reserved_parcel_not_found: 'ไม่พบข้อมูลพัสดุหมายเลข โปรดติดต่อศูนย์ช่วยเหลือร้านค้า',
        cage_not_found: 'Cage not found (กรุณาติดต่อ CS)',
        dop_parcel_not_found_triggered_auto_rts: 'พัสดุนี้ยังไม่ถูกกด Ready-To-Ship (ระบบอาจจะกำลังปรับสถานะ กรุณารอสักครู่)',
        station_not_active: 'จุดรับพัสดุไม่สามารถใช้งานได้',
        parcel_already_inbound: 'พัสดุถูกสแกนสองครั้ง กรุณาติดต่อจุดบริการเพื่อยืนยันนำเข้าระบบ',
        station_is_not_dop: 'ไม่สามารถ Dropoff พัสดุที่นี่ได้',
        dop_parcel_status_not_whitelist: 'สถานะพัสดุไม่ถูกต้อง',
        cannot_inbound_cancelled_parcels_by_customer: 'พัสดุถูกยกเลิกโดยลูกค้า',
        cannot_inbound_cancelled_task: 'พัสดุถูกยกเลิก',
        package_was_cancelled: 'พัสดุถูกยกเลิก',
        dop_merchant_mdop: 'The seller of the parcel is MDOP',
        duplicate_request: 'Your request is processing',
        unexpected_error: 'Mostly the stacktrace of unexpected error'
    }
}